import { render } from "./Apartments.vue?vue&type=template&id=c6f5d8c6&scoped=true"
import script from "./Apartments.vue?vue&type=script&lang=js"
export * from "./Apartments.vue?vue&type=script&lang=js"

import "./Apartments.vue?vue&type=style&index=0&id=c6f5d8c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6f5d8c6"]])

export default __exports__